<mat-nav-list appAccordion class="navigation">
  <mat-list-item appAccordionLink *ngFor="let menuitem of menuService.getAll()" group="{{menuitem.state}}">
    <a appAccordionToggle class="relative" [routerLink]="['/', menuitem.state]" *ngIf="menuitem.type === 'link'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
    </a>
    <a appAccordionToggle class="relative" href="{{menuitem.state}}" *ngIf="menuitem.type === 'extLink'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
    </a>
    <a appAccordionToggle class="relative" href="{{menuitem.state}}" target="_blank"
      *ngIf="menuitem.type === 'extTabLink'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
    </a>
    <a appAccordionToggle class="relative" href="javascript:;" *ngIf="menuitem.type === 'sub'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
    </a>
    <mat-nav-list class="sub-menu" *ngIf="menuitem.type === 'sub'">
      <mat-list-item *ngFor="let childitem of menuitem.children" routerLinkActive="open">
        <a [routerLink]="['/', menuitem.state, childitem.state ]" class="relative">{{ childitem.name | translate }}</a>
      </mat-list-item>
    </mat-nav-list>
  </mat-list-item>
  <mat-list-item appAccordionLink group="testHeadset" *ngIf="devMode">
    <a appAccordionToggle class="relative" (click)="checkHeadset()">
      <mat-icon color="primary">headset_mic</mat-icon>
      <span>{{ 'user.content.test_headset' | translate }}</span>
    </a>
  </mat-list-item>
  <mat-list-item appAccordionLink>
    <a appAccordionToggle class="relative" (click)="openLiveTracking()">
      <mat-icon color="primary">data_thresholding</mat-icon>
      <span>{{ 'user.content.live_tracking' | translate }} {{myEnterprise?.name}}</span>
    </a>
  </mat-list-item>
  <mat-list-item appAccordionLink group="enterpriseContact">
    <a appAccordionToggle class="relative" (click)="openEnterpriseContact()">
      <mat-icon color="primary">contacts</mat-icon>
      <span>{{ 'menu.show_contact' | translate }}</span>
    </a>
  </mat-list-item>
  <mat-list-item appAccordionLink group="logout">
    <a appAccordionToggle class="relative" (click)="logout()">
      <mat-icon color="primary">exit_to_app</mat-icon>
      <span>{{ 'menu.logout' | translate }}</span>
    </a>
  </mat-list-item>
  <mat-list-item appAccordionLink group="quit" *ngIf="isElectronApp()">
    <a appAccordionToggle class="relative" (click)="quit()">
      <mat-icon color="primary">power_settings_new</mat-icon>
      <span>{{ 'menu.quit' | translate }}</span>
    </a>
  </mat-list-item>
  <mat-list-item appAccordionLink>
    <a appAccordionToggle class="relative" (click)="issueReport()">
      <mat-icon color="primary">report_problem</mat-icon>
      <span>{{ 'menu.issue_report' | translate }}</span>
    </a>
  </mat-list-item>
</mat-nav-list>
